import { nerdNetworkBaseQuery } from "@nerdjs/nerd-network";
import { createApi } from "@reduxjs/toolkit/query/react";

export const kronosApi = createApi({
  reducerPath: "kronosApi",
  baseQuery: (args, api) =>
    nerdNetworkBaseQuery(args, api, { service: "kronos" }),
  endpoints: () => ({}),
  tagTypes: [
    "kronosProjects",
    "kronosTasks",
    "kronosUsers",
    "kronosTimers",
    "kronosTimerSearchMetadata",
  ],
});
